import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { Card } from "../../../components/ui";
import {
  DataTable,
  type DataColumn,
} from "../../../components/ui/table/DataTable";
import { AppShell } from "../../../layouts/AppShell";
import { listMaterials } from "../api/materialApi";
import type { Material } from "../schemas/materialSchemas";

const columns: readonly DataColumn<Material>[] = [
  {
    id: "title",
    header: "教材名稱",
    cell: (material) => (
      <Link to={`/materials/${material.id}`}>{material.title}</Link>
    ),
  },
  {
    id: "description",
    header: "說明",
    cell: (material) => material.description,
  },
];
export function MaterialListPage() {
  const query = useQuery({
    queryKey: ["materials"],
    queryFn: () => listMaterials(),
  });
  return (
    <AppShell title="教材" breadcrumb={["教材"]}>
      <Card>
        <DataTable
          caption="可取得教材"
          columns={columns}
          rows={query.data?.items ?? []}
          rowKey={(row) => row.id}
          loading={query.isLoading}
          error={query.error instanceof Error ? query.error.message : undefined}
        />
      </Card>
    </AppShell>
  );
}
